import type {
  ClientAccountTypeEnum,
  ClientQuery,
  CreditTypeEnum,
  StripePaymentMethod,
} from "@/__generated__/graphql";
import type { NonNullableCollection } from "./app";
import { type NotificationSettingValues } from "@/containers/notifications/notification-settings/lib";

export type Contact = {
  id: string;
  firstName: string;
  lastName: string;
  primary: boolean;
  email: string[];
  phoneNumber: string[];
};

export type Address = {
  id?: string;
  label?: string;
  postalCode: string;
  fullAddress?: string;
  unitNumber?: string; //eg: #05-518
  primary: boolean;
  active: boolean;
};

export type User = {
  id: string;
  email: string;
  phoneNumber?: string;
  phoneNumberVerifiedAt?: string;
  emailVerifiedAt?: string;
};

export type LinkedDepartment = {
  linkedType: "Department";
  id: string;
  name: string;
};

export type LinkedPackage = {
  linkedType: "Package";
  id: string;
};

export type UserCreditAccount = {
  id: string;
  creditType: CreditTypeEnum;
  balance: number;
  linkedObject?: LinkedDepartment | LinkedPackage | null;
};

export type UserPaymentMethod = Omit<
  StripePaymentMethod,
  "__typename" | "country" | "cardType"
>;

type UserInfoBillingAccount = NonNullableCollection<
  Omit<ClientQuery["client"]["billingAccount"], "__typename">
>;

export type UserInfo = {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  user: User;
  contacts: Contact[];
  addresses: Address[];
  accountType: ClientAccountTypeEnum;
  creditAccounts: UserCreditAccount[];
  paymentMethod: UserPaymentMethod | null;
  autoPay: boolean;
  billingAccount: UserInfoBillingAccount;
  notificationSettings: NotificationSettingValues;
};

export enum LoginType {
  Login = "Login",
  EmailLogin = "EmailLogin",
  SignUp = "SignUp",
  Confirm = "Confirm",
}

export enum AuthModals {
  LOGIN = "login",
  OTP = "otp",
  SIGN_UP = "signUp",
  EMAIL_LOGIN = "emailLogin",
  FORGOT_PASSWORD = "forgotPassword",
  ADDRESS = "address",
  WELCOME = "welcome",
  LOGOUT = "logout",
}

export enum SignUpStep {
  ValidateNumber = "ValidateNumber",
  AddAddress = "AddAddress",
}
